import { Outlet, useMatches, useLocation } from "react-router";
import { useEffect, useMemo } from "react";
import { Header } from "./header";
import { Footer } from "./footer";
import { Breadcrumbs } from "../app/Breadcrumbs";
import type { RouteHandle } from "../types/router";
import ScrollToTop from "../utils/scroll-to-top";
import { CatalogFilterProvider } from "../context/CatalogFilterContext";
import { CartProvider } from "../context/CartContext";

const PageTitleUpdater = () => {
    const matches = useMatches();
    const location = useLocation();

    useEffect(() => {
        const activeMatch = matches[matches.length - 1];
        const handle = activeMatch?.handle as RouteHandle | undefined;
        const title = handle?.title;

        if (typeof title === 'function') {
            document.title = `${title(activeMatch)} — Slidy`;
        } else if (title) {
            document.title = `${title} — Slidy`;
        } else {
            document.title = 'Slidy';
        }
    }, [matches, location.pathname]);

    // Blur all inputs and textareas when the body is clicked
    // this will autohide the keyboard on mobile devices
    useEffect(() => {
        const handleBodyClick = (e: MouseEvent) => {
          // Check if the clicked element is not an input or textarea
          const target = e.target as HTMLElement;
          if (!target.closest('input, textarea')) {
            // Find all inputs and textareas and blur them
            document.querySelectorAll('input, textarea').forEach((element) => {
              (element as HTMLElement).blur();
            });
          }
        };
    
        document.body.addEventListener('click', handleBodyClick);
    
        return () => {
          document.body.removeEventListener('click', handleBodyClick);
        };
      }, []);

    return null;
};

const Layout = () => {
    return useMemo(() => (
        <CartProvider>
            <CatalogFilterProvider>
                <PageTitleUpdater />
                <ScrollToTop />
                <Header />

                <main className="main">
                    <Breadcrumbs />
                    <Outlet />
                </main>
                <Footer />
            </CatalogFilterProvider>
        </CartProvider>
    ), []);
};

export default Layout;